import { render, staticRenderFns } from "./StatementsAll.vue?vue&type=template&id=7b4aa1fa&scoped=true"
import script from "./StatementsAll.vue?vue&type=script&lang=js"
export * from "./StatementsAll.vue?vue&type=script&lang=js"
import style0 from "./StatementsAll.vue?vue&type=style&index=0&id=7b4aa1fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4aa1fa",
  null
  
)

export default component.exports